document.addEventListener('DOMContentLoaded', function() {
    const banner = document.getElementById('cookie-banner');
    if (!banner) return;
    banner.style.display = 'block';

    function setConsent(value) {
        const days = 365;
        const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
        document.cookie = `cookie_consent=${value}; path=/; expires=${expires}; SameSite=Lax`;
        banner.remove();
        if (value === 'accepted') { enableNonEssential(); }
    }

    document.getElementById('cookie-accept').addEventListener('click', ()=> setConsent('accepted'));
    document.getElementById('cookie-decline').addEventListener('click', ()=> setConsent('declined'));

    // If cookie already set and accepted, enable on load
    if (document.cookie.split('; ').find(row => row.startsWith('cookie_consent=accepted'))) {
        enableNonEssential();
    }

    function enableNonEssential() {
        // Example: dynamically load analytics only when accepted
        const script = document.createElement('script');
        script.src = '/path/to/your/analytics.js'; // replace or remove if none
        script.async = true;
        document.head.appendChild(script);
    }
});
